import { Pipe, PipeTransform, inject } from '@angular/core';
import {IconType} from "@angular/material/icon/testing";
import {SvgIconsService} from "../../services/svg/svg-icons.service";

@Pipe({ name: 'iconType' })
export class IconTypePipe implements PipeTransform {
  iconsService = inject(SvgIconsService);

  transform(icon: string) {
    return this.iconsService.getType(icon);
  }
}
